import React, { useState } from 'react';
import axios from 'axios';
import * as Icon from 'react-bootstrap-icons'
import { ToastContainer, toast } from 'react-toastify';

const Contact = () => {
  const [toggleValue, setToggleValue] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    userId: '',
    email: '',
    message: '',
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem('token');

    // Send form data to backend API
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}order/contact`,
        formData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );

      if (response.data.message === 'error') {
        toast.warn('An error occurred. Please try again.');
      } else {
        toast.success('Email sent successfully.');
        // toast.success('Email sent successfully.' || response.data.message);
        setFormSubmitted(true);  // Show success message
        setErrorMessage(''); // Clear any previous error messages
        setTimeout(() => {
          setFormData({
            userId: '',
            email: '',
            message: '',
          });
          setFormSubmitted(false);  // Hide success message after form reset
        }, 5000);
      }
    } catch (error) {
      setErrorMessage('Failed to submit the form. Please try again later.');
    }
  };


  return (
    <div className="container-fluid">
      <div className="col-12 p-lg-5 p-md-4 mt-lg-0 mt-md-3 mt-3 dashboard-wrapper">
        <Icon.ArrowRight onClick={() => setToggleValue(true)} className='my-5 sidebar-open' color='black' size={30}></Icon.ArrowRight>

        <div className='row dashboard-content mt-lg-0 mt-md-3 mt-3'>

          <div
            style={{

              padding: '20px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '100vh',
              backgroundColor: '#fefeec',
            }}
          >
            <div
              style={{
                backgroundColor: '#fff',
                padding: '20px',
                borderRadius: '10px',
                boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                maxWidth: '600px',
                width: '100%',  // Ensure it doesn't exceed screen width
              }}
            >
              <h4 style={{ marginBottom: '20px' }}>Contact Support</h4>
              {formSubmitted ? (
                <div style={{ color: 'green', fontSize: '16px' }}>
                  Thank you! Your message has been submitted successfully.
                </div>
              ) : (
                <form
                  onSubmit={handleSubmit}
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '15px',  // Adds spacing between form fields
                  }}
                >
                  {errorMessage && (
                    <div style={{ color: 'red', fontSize: '16px', marginBottom: '15px' }}>
                      {errorMessage}
                    </div>
                  )}
                  <div>
                    <label style={{ display: 'block', marginBottom: '5px' }}>UserId:</label>
                    <input
                      type="text"
                      name="userId"
                      value={formData.userId}
                      onChange={handleChange}
                      placeholder="Enter your userId"
                      required
                      style={{
                        width: '100%',
                        padding: '10px',
                        borderRadius: '5px',
                        border: '1px solid #ccc',
                      }}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', marginBottom: '5px' }}>Email:</label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                      style={{
                        width: '100%',
                        padding: '10px',
                        borderRadius: '5px',
                        border: '1px solid #ccc',
                      }}
                    />
                  </div>

                  <div>
                    <label style={{ display: 'block', marginBottom: '5px' }}>Message:</label>
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Write your message here..."
                      rows="5"
                      required
                      style={{
                        width: '100%',
                        padding: '10px',
                        borderRadius: '5px',
                        border: '1px solid #ccc',
                      }}
                    ></textarea>
                  </div>

                  <button
                    type="submit"
                    style={{
                      backgroundColor: '#597e52',
                      color: 'white',
                      padding: '10px 20px',
                      border: 'none',
                      borderRadius: '5px',
                      cursor: 'pointer',
                      fontSize: '16px',
                    }}
                  >
                    Submit
                  </button>
                </form>
              )}
            </div>
          </div>
          <ToastContainer theme="dark" autoClose={2000} />


        </div>


      </div>
    </div>

  );
};

export default Contact;
